__turbopack_context__.v({
  "link": "Link-module__dkcdzG__link",
  "linkIcon": "Link-module__dkcdzG__linkIcon",
  "linkText": "Link-module__dkcdzG__linkText",
});
